import { formatMoodForSubmit } from "./formOptions";
import { convertToIsoDateTime } from "../datetime";

const prepareObservationsData = (
  data,
  recordData,
  customerRecordData,
  moodOptions,
  siteGuid,
  linkedAlertData,
) => {
  let record = { ...recordData, site: { ...recordData.site, guid: siteGuid } };

  let moods = [];
  data.customerMood.forEach((mood) => {
    moods.push(formatMoodForSubmit(mood, moodOptions));
  });

  return {
    ...record,
    id: data.id,
    rowVersion: data.rowVersion,
    observationDate: convertToIsoDateTime(
      data.observationDate,
      data.observationTime,
    ),
    customerId: data.customerId ? data.customerId : 0,
    customer: data.customerId
      ? null
      : { ...customerRecordData, ...data.customer },
    behaviour: data.observation,
    moods,
    comments: data.comments,
    reminderDate: data.setReminder
      ? convertToIsoDateTime(data.reminderDate, data.reminderTime)
      : null,
    sessionGuids: data.sessionGuids,
    alertIds: linkedAlertData.map((x) => x.id),
  };
};

export default prepareObservationsData;
